import ExpertStrip from "@/components/v2/ExpertStrip";

export default function Layers() {
    return (
        <section
            className="layers"
            id="layers"
            data-testid="v2-layers"
        >
            <div className="container">
                <div className="layers__head reveal">
                    <span className="layers__eyebrow">The Three Layers</span>
                    <h2 className="layers__title" data-testid="v2-layers-title">
                        Management. Capital. <em>Counsel.</em>
                        <br />
                        Three layers, one system.
                    </h2>
                    <p className="layers__sub">
                        C-ORE doesn&rsquo;t stop at the dashboard. It also prepares
                        your business for capital and connects you with the
                        experience you can&rsquo;t hire full-time.
                    </p>
                </div>

                <div className="layers__grid">
                    {/* C-ORE Fund */}
                    <article
                        className="layer__card layer__card--fund reveal"
                        data-testid="v2-layer-fund"
                    >
                        <span className="layer__label">
                            <span className="layer__label-dot" aria-hidden="true" />
                            Layer 01 &middot; Capital
                        </span>
                        <h3 className="layer__name">C-ORE Fund</h3>
                        <p className="layer__tag">
                            Make your business ready for capital.
                        </p>
                        <p className="layer__body">
                            C-ORE Fund assesses your investment and lending
                            readiness, prepares the required financial and
                            business documentation, and connects you with
                            relevant funding opportunities.
                        </p>
                        <a
                            className="layer__link"
                            href="#pricing"
                            data-testid="v2-layer-fund-link"
                        >
                            See how Fund works
                            <span className="layer__link-arrow" aria-hidden="true">
                                &rarr;
                            </span>
                        </a>
                    </article>

                    {/* C-ORE Expert */}
                    <article
                        className="layer__card layer__card--expert reveal"
                        data-testid="v2-layer-expert"
                    >
                        <span className="layer__label">
                            <span className="layer__label-dot" aria-hidden="true" />
                            Layer 02 &middot; Expert Guidance
                        </span>
                        <h3 className="layer__name">C-ORE Expert</h3>
                        <p className="layer__tag">
                            When the decision needs experience, not just data.
                        </p>
                        <p className="layer__body">
                            Connect with experienced CEOs, CFOs, CMOs, CTOs and
                            industry experts who understand your business
                            context and help you make better decisions.
                        </p>
                        <a
                            className="layer__link"
                            href="#pricing"
                            data-testid="v2-layer-expert-link"
                        >
                            See how Expert works
                            <span className="layer__link-arrow" aria-hidden="true">
                                &rarr;
                            </span>
                        </a>
                    </article>
                </div>

                <ExpertStrip />

                <div className="layers__bridge reveal" data-testid="v2-layers-bridge">
                    <span className="layers__bridge-num">Layer 03 &middot; Management</span>
                    <p className="layers__bridge-text">
                        <strong>C-ORE CEO, CFO, CMO &amp; CTO</strong> &mdash; the
                        management layer that runs your business every day. Meet
                        the C-Suite below.
                    </p>
                </div>
            </div>
        </section>
    );
}
